import React from 'react';
import {noop} from 'lodash';

import {BusinessBuilderBonusBanner} from '/component/screen/Dashboard/BonusBannerCards/BusinessBuilderBonusBanner';

export const BusinessBuilderBonusProfileCard = ({
  hasBusinessBuilderBonusContributors = false,
  BBBonusContributorCurrentDate = '',
  BBBonusContributorActivationDate = '',
  BBBonusContributors = [],
  popoverShow = noop,
}: any) => {
  return (
    <BusinessBuilderBonusBanner
      title={'Business Builder Bonus Contributor'}
      hasBusinessBuilderBonusContributors={hasBusinessBuilderBonusContributors}
      BBBonusContributorActivationDate={BBBonusContributorActivationDate}
      BBBonusContributorCurrentDate={BBBonusContributorCurrentDate}
      BBBonusContributors={BBBonusContributors}
      isBBBProfileCard
      popoverShow={popoverShow}
    />
  );
};
